<div
  class="menu"
  fxHide
  fxLayout="row"
  fxShow.gt-sm
>
  @for (item of sidenavItems$ | async; track $index; let index = $index) {
  <div>
    @if (index < showMoreButtonAfterIndex && item.type !== 'subheading') { @if (!item.subItems ||
    item.subItems.length === 0) {
    <fury-navigation-item
      [currentlyOpen]="currentlyOpen$ | async"
      (handleClick)="handleClick($event)"
      [item]="item"
    ></fury-navigation-item>
    } @else {
    <fury-navigation-item
      [currentlyOpen]="currentlyOpen$ | async"
      [item]="item"
      [matMenuTriggerData]="{ item: item }"
      [matMenuTriggerFor]="dropdown"
    ></fury-navigation-item>
    } } @if (index == showMoreButtonAfterIndex) {
    <div
      class="more-button-container"
      fxLayout="row"
      fxLayoutAlign="start center"
    >
      <button
        [matMenuTriggerFor]="moreMenu"
        class="more-button"
        mat-icon-button
      >
        <mat-icon>more_vert</mat-icon>
      </button>
    </div>
    }
  </div>
  }
</div>

<mat-menu
  #dropdown="matMenu"
  [overlapTrigger]="false"
>
  <ng-template
    let-item="item"
    matMenuContent
  >
    @for (subItem of item.subItems; track $index) { @if (!subItem.subItems ||
    subItem.subItems.length === 0) {
    <button
      (click)="handleClick(subItem)"
      mat-menu-item
    >
      <span>{{ subItem.name }}</span>
    </button>
    } @else {
    <button
      [matMenuTriggerData]="{ item: subItem }"
      [matMenuTriggerFor]="dropdownLevel2"
      mat-menu-item
    >
      <span>{{ subItem.name }}</span>
    </button>
    } }
  </ng-template>
</mat-menu>

<mat-menu
  #dropdownLevel2="matMenu"
  [overlapTrigger]="false"
>
  <ng-template
    let-item="item"
    matMenuContent
  >
    @for (subItem of item.subItems; track $index) { @if (!subItem.subItems ||
    subItem.subItems.length === 0) {
    <button
      (click)="handleClick(subItem)"
      mat-menu-item
    >
      <span>{{ subItem.name }}</span>
    </button>
    } @else {
    <button
      [matMenuTriggerData]="{ item: subItem }"
      [matMenuTriggerFor]="dropdownLevel3"
      mat-menu-item
    >
      <span>{{ subItem.name }}</span>
    </button>
    } }
  </ng-template>
</mat-menu>

<mat-menu
  #dropdownLevel3="matMenu"
  [overlapTrigger]="false"
>
  <ng-template
    let-item="item"
    matMenuContent
  >
    @for (subItem of item.subItems; track $index) { @if (!subItem.subItems ||
    subItem.subItems.length === 0) {
    <button
      (click)="handleClick(subItem)"
      mat-menu-item
    >
      <span>{{ subItem.name }}</span>
    </button>
    } @else {
    <button
      [matMenuTriggerData]="{ item: subItem }"
      [matMenuTriggerFor]="dropdownLevel4"
      mat-menu-item
    >
      <span>{{ subItem.name }}</span>
    </button>
    } }
  </ng-template>
</mat-menu>

<mat-menu
  #dropdownLevel4="matMenu"
  [overlapTrigger]="false"
>
  <ng-template
    let-item="item"
    matMenuContent
  >
    @for (subItem of item.subItems; track $index) { @if (!subItem.subItems ||
    subItem.subItems.length === 0) {
    <button
      (click)="handleClick(subItem)"
      mat-menu-item
    >
      <span>{{ subItem.name }}</span>
    </button>
    } @else {
    <button
      [matMenuTriggerData]="{ item: subItem }"
      [matMenuTriggerFor]="dropdownLevel5"
      mat-menu-item
    >
      <span>{{ subItem.name }}</span>
    </button>
    } }
  </ng-template>
</mat-menu>

<mat-menu
  #dropdownLevel5="matMenu"
  [overlapTrigger]="false"
>
  <ng-template
    let-item="item"
    matMenuContent
  >
    @for (subItem of item.subItems; track $index) { @if (!subItem.subItems ||
    subItem.subItems.length === 0) {
    <button
      (click)="handleClick(subItem)"
      mat-menu-item
    >
      <span>{{ subItem.name }}</span>
    </button>
    } }
  </ng-template>
</mat-menu>

<mat-menu
  #moreMenu="matMenu"
  [overlapTrigger]="false"
>
  @for (item of sidenavItems$ | async; track $index; let index = $index) { @if (index >=
  showMoreButtonAfterIndex) { @for (subItem of item.subItems; track $index) { @if (!subItem.subItems
  || subItem.subItems.length === 0) {
  <button
    (click)="handleClick(subItem)"
    mat-menu-item
  >
    <span>{{ subItem.name }}</span>
  </button>
  } @else {
  <button
    [matMenuTriggerData]="{ item: subItem }"
    [matMenuTriggerFor]="dropdown"
    mat-menu-item
  >
    <span>{{ subItem.name }}</span>
  </button>
  } } } }
</mat-menu>
